import './SectionContainer.scss'

const SectionContainer = (props) => {
    const componentClass = 'smart-modals-section-container'

    return (
        <div className={componentClass}>
            {props.children}
        </div>
    )
}

export default SectionContainer
